import { useEffect, useState } from 'react';
import { DEPLOY_STALE_MS, isDeployInProgress, serverNowMs } from '../utils/deployStatus';
import { checkAppVersionNow } from './useAppVersionCheck';
const POLL_MS = 10 * 1000;
const STATUS_URL = '/deploy-status.json';
export function isDevPreviewAvisoDeploy() {
    if (process.env.NODE_ENV !== 'development')
        return false;
    if (typeof window === 'undefined')
        return false;
    return new URLSearchParams(window.location.search).get('avisoDeploy') === '1';
}
export function useDeployStatus() {
    const [inProgress, setInProgress] = useState(false);
    useEffect(() => {
        if (process.env.NODE_ENV === 'development' && !isDevPreviewAvisoDeploy()) {
            return undefined;
        }
        let cancelled = false;
        let intervalId = null;
        let lastFreshAt = 0;
        let active = false;
        // Consulta a versão antes de esconder, para o aviso de nova versão assumir sem intervalo vazio.
        const endDeploy = async () => {
            lastFreshAt = 0;
            if (active) {
                await checkAppVersionNow();
                if (cancelled || lastFreshAt !== 0)
                    return;
            }
            active = false;
            setInProgress(false);
        };
        // Soluço do proxy (5xx, corpo inválido, rede) não encerra o aviso; só 404 ou 60s sem batida.
        const keepUnlessExpired = async () => {
            if (lastFreshAt === 0 || Date.now() - lastFreshAt > DEPLOY_STALE_MS) {
                await endDeploy();
            }
        };
        const check = async () => {
            try {
                const response = await fetch(`${STATUS_URL}?t=${Date.now()}`, {
                    cache: 'no-store',
                    credentials: 'same-origin',
                });
                if (cancelled)
                    return;
                if (response.status === 404) {
                    await endDeploy();
                    return;
                }
                if (!response.ok) {
                    await keepUnlessExpired();
                    return;
                }
                let payload;
                try {
                    payload = await response.json();
                }
                catch {
                    if (!cancelled)
                        await keepUnlessExpired();
                    return;
                }
                if (cancelled)
                    return;
                if (isDeployInProgress(payload, serverNowMs(response.headers.get('Date'), Date.now()))) {
                    lastFreshAt = Date.now();
                    active = true;
                    setInProgress(true);
                    return;
                }
                await endDeploy();
            }
            catch {
                if (cancelled)
                    return;
                await keepUnlessExpired();
            }
        };
        const startPolling = () => {
            void check();
            if (intervalId !== null)
                window.clearInterval(intervalId);
            intervalId = window.setInterval(check, POLL_MS);
        };
        const stopPolling = () => {
            if (intervalId !== null) {
                window.clearInterval(intervalId);
                intervalId = null;
            }
        };
        const onVisible = () => {
            if (document.visibilityState === 'visible')
                startPolling();
            else
                stopPolling();
        };
        if (document.visibilityState === 'visible')
            startPolling();
        window.addEventListener('focus', onVisible);
        document.addEventListener('visibilitychange', onVisible);
        return () => {
            cancelled = true;
            stopPolling();
            window.removeEventListener('focus', onVisible);
            document.removeEventListener('visibilitychange', onVisible);
        };
    }, []);
    return inProgress;
}
